import { isUndefined } from "lodash";

const formatRankWithOrdinal = (rank: number | undefined, i18n: any): string => {
  if (isUndefined(rank)) {
    return "";
  }

  const j = rank % 10,
    k = rank % 100;
  if (j === 1 && k !== 11) {
    return rank + i18n("ordinal.1");
  }
  if (j === 2 && k !== 12) {
    return rank + i18n("ordinal.2");
  }
  if (j === 3 && k !== 13) {
    return rank + i18n("ordinal.3");
  }
  return rank + i18n("ordinal.default");
};

function formatEnumValue(value: string) {
  if (!value) {
    return "Not Started";
  }

  return value
    .split("_")
    .map((word: string) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
}

export { formatEnumValue, formatRankWithOrdinal };
